export default {
  "content": "<path d=\"M16.363 14.505A5.046 5.046 0 0112 17a5.046 5.046 0 01-4.363-2.495l1.726-1.01A3.047 3.047 0 0012 15c1.13 0 2.112-.607 2.637-1.505l1.726 1.01zM9.5 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM14.5 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};